import { IExport } from "@shared/interfaces/IExcelExport";
import { EventEmitter, Injectable } from "@angular/core";

@Injectable()
export class ExportService {
    OnExportToExcel = new EventEmitter();
    OnExportToPDF = new EventEmitter();
    OnExportToCSV = new EventEmitter();
    public ExcelExportEvent = this.OnExportToExcel.asObservable();
    public PDFExportEvent = this.OnExportToPDF.asObservable();
    public CSVExportEvent = this.OnExportToCSV.asObservable();
    constructor() {
    }
    ExportToExcel(exportConfig: IExport) {
        this.OnExportToExcel.emit(exportConfig);
    }
    ExportToPDF(exportConfig: IExport) {
        this.OnExportToPDF.emit(exportConfig);
    }
    ExportToCSV(exportConfig: IExport) {
        this.OnExportToCSV.emit(exportConfig);
    }
}